import { API, Auth } from 'aws-amplify'

const POST_NEW_INVITATION_CODE = async function(data) {
  let apiName = 'ecobanka'
  let path = '/invitation-codes'
  let myInit = {
    body: {
      data: data
    },
    headers: {
      Authorization: (await Auth.currentSession()).idToken.jwtToken
    }
  }
  return await API.post(apiName, path, myInit)
}

const POST_REQUEST_INVITATION = async function(data) {
  let apiName = 'ecobanka'
  let path = '/invitation-codes/request'
  let myInit = {
    body: {
      data: data
    }
  }
  return await API.post(apiName, path, myInit)
}


const GET_INVITATION_CODES = async function() {
  let apiName = 'ecobanka'
  let path = '/invitation-codes'
  let myInit = {
    headers: {
      Authorization: (await Auth.currentSession()).idToken.jwtToken
    }
  }

  return await API.get(apiName, path, myInit)
}

const DELETE_INVITATION_CODE = async function(invitationCode) {
  let apiName = 'ecobanka'
  let path = '/invitation-codes/' + invitationCode
  let myInit = {
    headers: {
      Authorization: (await Auth.currentSession()).idToken.jwtToken
    }
  }
  return await API.del(apiName, path, myInit)
}

const GET_INVITATION_CODE_DETAILS = async function(invitationCode) {
  let apiName = 'ecobanka'
  let path = '/invitation-codes/' + invitationCode
  return await API.get(apiName, path)
}

export {
  POST_NEW_INVITATION_CODE,
  POST_REQUEST_INVITATION,
  GET_INVITATION_CODES,
  DELETE_INVITATION_CODE,
  GET_INVITATION_CODE_DETAILS
}
